module.exports = __webpack_public_path__ + "img/chr_ts_24.6bf3c265.png";